export function parseBankAccount(bankAccount) {
    if (!bankAccount) {
        return null;
    }
    const match = bankAccount.match(/^(?:(\d{1,6})-)?(\d{8,10})\/(\d{4})$/);
    if (!match) {
        return null;
    }
    const prefix = ('000000' + (match[1] || '')).slice(-6);
    const account = ('0000000000' + match[2]).slice(-10);
    const bankCode = match[3];
    return { prefix, account, bankCode };
}
